import { BASE_URL_INTEGRATION, OTHER_BASE_URL_INTEGRATIONS } from 'app-constants';
import * as R from 'ramda';
import { COMMENT } from 'app-constants/actionTypes';
import { botspecsActions } from '../reducer';
import slugify from './utils';

export const { updateBotspecParsingErrors } = botspecsActions;

const validateEntryPoint = (entrypoint) => (!entrypoint ? 'There is no entrypoint defined' : '');

/**
 * Títulos de nodo repetidos. Cada nodo debe tener un nombre único: las transiciones implícitas
 * se llaman `map_result_implicit_<título>` (sin el id), así que dos nodos con el mismo título
 * comparten transición y el bot queda cruzado.
 * @param {Record<string, any>} nodes - reteJson.nodes
 * @returns {string[]}
 */
export const findDuplicateNodeTitles = (nodes = {}) => {
  /** @type {Record<string, string[]>} */
  const byTitle = {};
  Object.values(nodes).forEach((node) => {
    if (slugify(node?.name || '') === COMMENT) return;
    const title = node?.data?.title;
    if (!title) return;
    const key = slugify(title);
    byTitle[key] = [...(byTitle[key] || []), title];
  });
  return Object.values(byTitle).filter((titles) => titles.length > 1).map((titles) => titles[0]);
};

export const duplicateTitlesMessage = (titles) => (titles.length
  ? `Hay nodos con el mismo nombre (${titles.join(', ')}). Cada nodo debe tener un nombre único; si no, el bot se cruza. No se guardó.`
  : '');

export const validateSpec = (reteJson) => {
  const { entryPoint } = reteJson;
  const messages = [
    validateEntryPoint(entryPoint),
    duplicateTitlesMessage(findDuplicateNodeTitles(reteJson.nodes)),
  ].filter((message) => message !== '');

  return messages;
};

export const updateIntegrationUrl = (specJson) => {
  const urlMappings = OTHER_BASE_URL_INTEGRATIONS.reduce(
    (mapping, url) => ({
      ...mapping,
      [new URL(url).hostname]: new URL(BASE_URL_INTEGRATION).hostname,
    }),
    {},
  );

  const updatedUrl = (rawUrl) => {
    const url = new URL(rawUrl);
    url.hostname = urlMappings[url.hostname] ?? url.hostname;
    return url.toJSON();
  };

  const updatedCallAPIAction = (action, rawUrl) => R.assocPath(['eval', 'url'], updatedUrl(rawUrl), action);
  const updatedActions = (actions) => Object.keys(actions).reduce(
    (newActions, key) => {
      const action = actions[key];
      const rawUrl = action.eval?.url;
      if (action.type === 'call_api' && URL.canParse(rawUrl)) {
        return {
          ...newActions,
          [key]: updatedCallAPIAction(action, rawUrl),
        };
      }
      return { ...newActions, [key]: actions[key] };
    },
    {},
  );

  // the URL of the integrations are only in the JSON spec actions
  return R.mergeDeepRight(specJson, {
    actions: updatedActions(specJson.actions),
  });
};
